import { render, staticRenderFns } from "./AutoRenewBtnToggle.vue?vue&type=template&id=706411be&"
import script from "./AutoRenewBtnToggle.vue?vue&type=script&lang=ts&"
export * from "./AutoRenewBtnToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QToggle} from 'quasar'
component.options.components = Object.assign({QBtnGroup,QBtn,QToggle}, component.options.components || {})
